import React, { useRef, useState } from "react";
import "./Urlshortener.css";
import Button from "react-bootstrap/Button";
import { Col, Row } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import { CopyIcon, CloseIcon } from "../../Icons/Svgicons";
import axios from "axios";

const Urlshortener = () => {
    const [isLoading, setLoading] = useState(false);
    const [longUrl, setLongUrl] = useState(null);
    const [wrongUrl, setWrongUrl] = useState(false);
    const [shortUrl, setShortUrl] = useState(false);
    const [generatedUrl, setGeneratedUrl] = useState(null);
    const [copy, setCopied] = useState("Copy");

    const textRef = useRef(null);

    function isValidUrl(url) {
        const urlRegex = /^(https?):\/\/[^\s/$.?#].[^\s]*$/;
        return urlRegex.test(url);
    }
    const handleClick = () => {
        setLoading(true);
        if (!isValidUrl(longUrl)) {
            setLoading(false);
            setWrongUrl(true);
            return true;
        }

        axios
            .post(`${process.env.REACT_APP_BASE_URL}/long-url`, {
                longUrl: longUrl,
            })
            .then((res) => {
                setLoading(false);
                setShortUrl(true);
                setGeneratedUrl(res.data.shortUrl);
            })
            .catch((err) => {
                console.log("error", err);
            });
    };

    const handleUrl = (e) => {
        setLongUrl(e.target.value);
    };

    const copyToClipBoard = () => {
        if (textRef.current) {
            const textValue = textRef.current.innerText.slice(0, -4);
            navigator.clipboard
                .writeText(textValue)
                .then(() => {
                    setCopied("Copied");
                    console.debug("copied");
                    setTimeout(() => {
                        setCopied("Copy");
                    }, [1500]);
                })
                .catch((err) => {
                    console.error("Unable to copy", err);
                });
        }
    };

    return (
        <>
            <div className="mt-4 shortener-body">
                <h2 className="text-center">Free URL Shortener</h2>
                <p className="text-center">
                    Free tool to shorten URLs, developed by{" "}
                    <a
                        href="https://www.nikhilnambi.in/"
                        rel="noreferrer"
                        target="_blank"
                    >
                        Nikhil Nambi
                    </a>
                    . Create short & memorable links in seconds.
                </p>
                <Row
                    className="justify-content-center align-items-center m-1 "
                    style={{ width: "100%" }}
                >
                    <Col lg={4} xs={12} sm={12} md={4}>
                        <input
                            type="url"
                            className="form-input w-100"
                            maxLength="256"
                            name="url"
                            data-name="Url"
                            placeholder="Enter link here"
                            id="url"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="none"
                            onChange={handleUrl}
                        />
                    </Col>
                    <Col
                        xs={12}
                        sm={12}
                        md={4}
                        lg={3}
                        className="mt-sm-3 mt-xs-4 mt-lg-0 mt-md-0 mt-xl-0"
                    >
                        <Button
                            size="lg"
                            className="button text-sm-center w-md-100 w-100 w-lg-75"
                            onClick={handleClick}
                        >
                            {isLoading ? "Loading…" : "Shorten URL"}
                        </Button>
                    </Col>
                </Row>

                <Row className="justify-content-center align-items-center mt-4 m-2">
                    <Col xs={12} sm={12} md={6} lg={7}>
                        {wrongUrl && (
                            <>
                                <Alert variant="danger" className="text-start">
                                    Invalid URL
                                    <div
                                        className="float-right"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            setWrongUrl(false);
                                        }}
                                    >
                                        <CloseIcon />
                                    </div>
                                </Alert>
                            </>
                        )}
                        {shortUrl && (
                            <>
                                <Alert
                                    variant="primary"
                                    className="text-start"
                                    ref={textRef}
                                >
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="flex-grow-1">
                                            {generatedUrl}
                                        </div>
                                        <Button
                                            className="btn btn-sm alert-button text-grey p-0 ml-2"
                                            onClick={copyToClipBoard}
                                        >
                                            {copy}
                                            <CopyIcon />
                                        </Button>
                                    </div>
                                </Alert>
                            </>
                        )}
                    </Col>
                </Row>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            maxWidth: "80%",
                            padding: "20px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            backgroundColor: "#f9f9f9",
                        }}
                    >
                        <p
                            style={{
                                fontSize: "14px",
                                lineHeight: "1.5",
                                padding: "8px",
                            }}
                        >
                            A URL shortener is a tool that takes long,
                            complicated web addresses and makes them much
                            shorter and easier to share. It's like using a
                            nickname for a web link. These shorter links are
                            helpful for sharing on social media or in texts.When
                            you click on a shortened link, it redirects you to
                            the original, longer web address, working like a
                            shortcut to get you where you want to go.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Urlshortener;
